<template>
  
<span>

	<Menu/>

	<b-row class="mt-3">
		
		<b-col cols="12">

			<b-card no-body class="mt-3 overflow-hidden" >
				<b-row no-gutters>
					<b-col md="6" order="1" order-md="2">
						<b-card-img 
							:src="require('../../assets/stock/do-more.jpg')" 
							alt="Do More" 
							class="rounded-0"></b-card-img>
					</b-col>
					<b-col md="6" order="2" order-md="1">
						<b-card-body title="What is Principal Task?">
							
							<b-row>
								<b-col>
									<p class="lead">
										Principal Task is a modern task manager built for productive people 
										(or those who want to be).  It's available on all of your devices 
										so its ready any time you need to update your list or 
										catch up on your day.  All of this power is available regardless 
										of your subscription type.	
									</p>
									<p class="lead">
										Scroll to learn more.	
									</p>
								</b-col>
							</b-row>

						</b-card-body>
					</b-col>
				</b-row>
			</b-card>

		</b-col>

    </b-row>

	
	<b-row class="mt-3">
		
		<b-col cols="12">

			<b-card no-body class="mt-3 overflow-hidden" >
				<b-row no-gutters>
					<b-col md="6" order="1" order-md="1">
						<b-card-img 
							:src="require('../../assets/stock/glass-ceiling.jpg')" 
							alt="Modern Architecture Glass Ceiling" 
							class="rounded-0"></b-card-img>
					</b-col>
					<b-col md="6" order="2" order-md="2">
						<b-card-body title="Modern">
							
							<b-row>
								<b-col>
									<p class="lead">Sleek and easy to use without the bloat of legacy task managers thus freeing you to be effective and productive.</p>
								</b-col>
							</b-row>
							
							
							<b-row>
								<b-col>
                                    <b-button to="/tour" variant="primary">Take a Tour</b-button> &nbsp;
									<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
										variant="success">Get Started</b-button>
								</b-col>
							</b-row>
						</b-card-body>
					</b-col>
				</b-row>
			</b-card>

		</b-col>

    </b-row>

	<b-row>
		
		<b-col cols="12">

			<b-card no-body class="mt-5 overflow-hidden" >
				<b-row no-gutters>
					
					<b-col md="6" order="1" order-md="2">
						<b-card-img 
							:src="require('../../assets/stock/woman-tablet.jpg')" 
							alt="Woman using tablet computer" 
							class="rounded-0"></b-card-img>
					</b-col>
					
					<b-col md="6" order="2" order-md="1">
						<b-card-body title="Mobile-friendly">
							<b-row>
								<b-col>
									<p class="lead">
										Take advantage of your spare time by using any internet connected device to
										review and adjust your task list.</p>	
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<b-button to="/tour" variant="primary">Take a Tour</b-button> &nbsp;
									<b-button :to="{name: 'signup', params: {action: 'signup'}}" 
										variant="success">Get Started</b-button>
								</b-col>
							</b-row>
							
						</b-card-body>
					</b-col>

					

				</b-row>
			</b-card>

		</b-col>

    </b-row>

	<b-row>
		
		<b-col cols="12">

			<b-card no-body class="mt-5 overflow-hidden" >
				<b-row no-gutters>
					<b-col md="6" order="1" order-md="1">
						<b-card-img 
							:src="require('../../assets/stock/compass.jpg')" 
							alt="Compass" 
							class="rounded-0"></b-card-img>
					</b-col>
					<b-col md="6" order="2" order-md="2">
						<b-card-body title="Analytical">
							<b-card-text>
								
								<b-row>
									<b-col>
										<p class="lead">
											Use the Dashboard to quickly review your day, week, or year.
										</p>
									</b-col>
								</b-row>

								<b-row>
									<b-col>
										<b-button to="/tour" variant="primary">Take a Tour</b-button> &nbsp;
									    <b-button :to="{name: 'signup', params: {action: 'signup'}}" 
											variant="success">Get Started</b-button>
									</b-col>
								</b-row>
								
								
							</b-card-text>
						</b-card-body>
					</b-col>
				</b-row>
			</b-card>

		</b-col>

    </b-row>	

	<b-row>
		
		<b-col cols="12">

			<b-card no-body class="mt-5 overflow-hidden" >
				<b-row no-gutters>
					
					<b-col md="6"  order="1" order-md="2">
						<b-card-img 
							:src="require('../../assets/stock/people.jpg')" 
							alt="Group of People" 
							class="rounded-0"></b-card-img>
					</b-col>
					
					<b-col md="6" order="2" order-md="1">
						<b-card-body title="Universal" class="h-100">

								<b-row>
									<b-col>
										
										<p class="lead">
											Beneficial to everyone from students to business people, from the haphazard to the hyper-organized.
										</p>
									</b-col>
								</b-row>

								<b-row>
									<b-col>
										<b-button to="/tour" variant="primary">Take a Tour</b-button> &nbsp;
									    <b-button :to="{name: 'signup', params: {action: 'signup'}}" 
											variant="success">Get Started</b-button>
									</b-col>
								</b-row>

							
						</b-card-body>
					</b-col>

					

				</b-row>
			</b-card>

		</b-col>

    </b-row>
</span>
</template>
<script>

	import Menu from '@/components/Menu.vue'

	export default {
		name: 'Landing2',
		components: {
            Menu
		},
		props: {
		},
		data () {
			return {

			}
		},
		methods: {},    

}
</script>